var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook logo"),React.createElement("description",{"key":1},"Find SendGrid on Facebook"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M.448 4.054h1.333V2.878c0-.518.014-1.318.43-1.812C2.647.54 3.248.184 4.279.184c1.682 0 2.39.218 2.39.218l-.333 1.792S5.78 2.05 5.262 2.05s-.983.168-.983.639v1.366h2.126l-.148 1.75H4.279v6.081H1.781V5.804H.448v-1.75z","fill":"#546B81"}))]);
}

FacebookIcon.defaultProps = {"width":"7px","height":"12px","viewBox":"0 0 7 12"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
